<template>
  <b-card>
    <!-- form -->
    <validation-observer ref="simpleRules">
      <b-form @submit.prevent>
        <b-row>
          <!-- old password -->
          <b-col md="6">
            <b-form-group label="Old Password" label-for="account-old-password" >
              <validation-provider #default="{ errors }"  name="old-password" rules="required">
                <b-input-group class="input-group-merge">
                  <b-form-input id="account-old-password" :state="errors.length > 0 ? false:null" v-model="passwordValueOld" name="old-password" :type="passwordFieldTypeOld" placeholder="Old Password" />
                  <b-input-group-append is-text> <feather-icon :icon="passwordToggleIconOld" class="cursor-pointer" @click="togglePasswordOld" /></b-input-group-append>
                </b-input-group>
              </validation-provider>
            </b-form-group>
          </b-col>
          <!--/ old password -->
        </b-row>
        <b-row>
          <!-- new password -->
          <b-col md="6">
            <b-form-group label-for="account-new-password" label="New Password">
              <validation-provider #default="{ errors }"  name="new-password" rules="required">
                <b-input-group class="input-group-merge">
                  <b-form-input id="account-new-password" :state="errors.length > 0 ? false:null" v-model="newPasswordValue" :type="passwordFieldTypeNew" name="new-password" placeholder="New Password" />
                  <b-input-group-append is-text> <feather-icon :icon="passwordToggleIconNew" class="cursor-pointer"  @click="togglePasswordNew" /> </b-input-group-append>
                </b-input-group>
              </validation-provider>
            </b-form-group>
          </b-col>
          <!--/ new password -->
          <!-- retype password -->
          <b-col md="6">
            <b-form-group label-for="account-retype-new-password" label="Retype New Password">
              <validation-provider #default="{ errors }"  name="retype-password" rules="required">
                <b-input-group class="input-group-merge">
                  <b-form-input id="account-retype-new-password" :state="errors.length > 0 ? false:null" v-model="RetypePassword" :type="passwordFieldTypeRetype" name="retype-password" placeholder="New Password" />
                  <b-input-group-append is-text> <feather-icon :icon="passwordToggleIconRetype" class="cursor-pointer" @click="togglePasswordRetype" /> </b-input-group-append>
                </b-input-group>
              </validation-provider>
            </b-form-group>
          </b-col>
          <!--/ retype password -->
          <!-- buttons -->
          <b-col cols="12">
            <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" class="mt-1 mr-1" @click.prevent="validationForm" > Save changes </b-button>
            <b-button v-ripple.400="'rgba(186, 191, 199, 0.15)'" type="reset" variant="outline-secondary" class="mt-1" > Reset </b-button>
          </b-col>
          <!--/ buttons -->
        </b-row>
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import {
  BButton, BForm, BFormGroup, BFormInput, BRow, BCol, BCard, BInputGroup, BInputGroupAppend,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { required } from '@validations'

export default {
  components: {
    ValidationProvider, 
    ValidationObserver,
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BCard,
    BInputGroup,
    BInputGroupAppend,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      required,
      passwordValueOld: '',
      newPasswordValue: '',
      RetypePassword: '',
      passwordFieldTypeOld: 'password',
      passwordFieldTypeNew: 'password',
      passwordFieldTypeRetype: 'password',
    }
  },
  computed: {
    passwordToggleIconOld() {
      return this.passwordFieldTypeOld === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    passwordToggleIconNew() {
      return this.passwordFieldTypeNew === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    passwordToggleIconRetype() {
      return this.passwordFieldTypeRetype === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
  },
  methods: {
    validationForm () {
      this.show = true
      this.$refs.simpleRules.validate()
      .then(success => {
        if (success) {
          if (this.newPasswordValue === this.RetypePassword) {
            const formData = {
              text_1:this.passwordValueOld,
              text_2:this.newPasswordValue
            } 
            this.$store.dispatch('profile/formPostPutPassword', formData)
            .then(res => {
              this.notification('Success','CheckIcon','success','You have successfully')
            }, 
            err => {
              this.show = false
              this.notification('Failed','CloseIcon','danger','You have unsuccessful')
            })
          } else {
            this.show = false
            this.notification('Failed','CloseIcon','danger','New Password & Retype Password Not Match')
          }
        } else {
          this.show = false
          this.notification('Failed','CloseIcon','danger','You have unsuccessful')
        }
      })
    },
    notification (a,b,c,d) {
      this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: { title: a, icon: b, variant: c, text: d}
      })
    },
    togglePasswordOld() {
      this.passwordFieldTypeOld = this.passwordFieldTypeOld === 'password' ? 'text' : 'password'
    },
    togglePasswordNew() {
      this.passwordFieldTypeNew = this.passwordFieldTypeNew === 'password' ? 'text' : 'password'
    },
    togglePasswordRetype() {
      this.passwordFieldTypeRetype = this.passwordFieldTypeRetype === 'password' ? 'text' : 'password'
    },
  },
}
</script>
